import * as React from 'react';
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import LoadingCmp from './LoadingCmp';
import { useState } from 'react';
import { useAppContext } from '../../providers/AppContext';
import { useIsFetching } from 'react-query';

export default function NavMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const { pageTitle, isNavMinimized, isScrolled: contextIsScrolled } = useAppContext();
  const isFetching = useIsFetching();

  function toggle() {
    setIsOpen(!isOpen);
  }

  const isScrolled = contextIsScrolled || isNavMinimized;

  return (
    <header className={`fixed-top ${isScrolled ? 'header-scrolled' : ''}`}>
      <Navbar
        className={`navbar-expand-sm navbar-toggleable-sm ${isScrolled ? 'scrolled' : ''}`}
        light
      >
        <Container className="headerContainer">
          <NavbarBrand tag={Link} to="/">
            Gazete Bayii
          </NavbarBrand>
          <span className="d-none d-md-block pageTitle" title={pageTitle}>
            {pageTitle}
          </span>
          {/* eslint-disable-next-line react/jsx-no-bind */}
          <NavbarToggler onClick={toggle} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={isOpen}
            navbar
          >
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="" to="/son-dakika">
                  Son Dakika
                </NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Container>
      </Navbar>
      {!!isFetching && <LoadingCmp />}
    </header>
  );
}
